import { render, staticRenderFns } from "./regEvent.vue?vue&type=template&id=44684778&"
import script from "./regEvent.vue?vue&type=script&lang=js&"
export * from "./regEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/regEvent.vue
// module id = 1327
// module chunks = 0